import { Breadcrumb, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';

import { createFileRoute, Link } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CorrectionModal,
  ExamCorrectionTable,
  useExamCorrectionGrid,
} from '@/features/exam-correction';
import type { ExamItemAnswerTextCorrectionGridItemRepositoryResponse } from '@/shared/api/generated/types';
import { PageHeader } from '@/shared/ui/organisms/PageHeader';

export const Route = createFileRoute('/_authenticated/exam/correction/$examPublishId/')({
  component: ExamCorrectionPage,
});

function ExamCorrectionPage() {
  const { t } = useTranslation('examCorrection');
  const { examPublishId } = Route.useParams();
  const examId = Number(examPublishId);

  const [page, setPage] = useState(1);
  const [selectedItem, setSelectedItem] =
    useState<ExamItemAnswerTextCorrectionGridItemRepositoryResponse | null>(null);
  const [selectedAnswerId, setSelectedAnswerId] = useState<number | null>(null);
  // Posição da resposta clicada na fila da questão — o modal navega a partir dela
  const [selectedPosition, setSelectedPosition] = useState(1);
  const [modalKey, setModalKey] = useState(0);

  const { items, totalPages, totalCount, isLoading } = useExamCorrectionGrid(examId, page);

  function handleCorrect(
    item: ExamItemAnswerTextCorrectionGridItemRepositoryResponse,
    answerId: number,
    position: number,
  ) {
    setSelectedItem(item);
    setSelectedAnswerId(answerId);
    setSelectedPosition(position);
    setModalKey(k => k + 1);
  }

  return (
    <>
      <div className="flex flex-col gap-lg">
        <PageHeader
          title={t('correction.title')}
          subtitle={t('correction.subtitle')}
          breadcrumb={
            <Breadcrumb>
              <BreadcrumbLink asChild>
                <Link to="/">{t('correction.breadcrumb.home')}</Link>
              </BreadcrumbLink>
              <BreadcrumbLink asChild>
                <Link to="/exam/correction-dashboard">{t('correction.breadcrumb.dashboard')}</Link>
              </BreadcrumbLink>
              <BreadcrumbPage>{t('correction.breadcrumb.correction')}</BreadcrumbPage>
            </Breadcrumb>
          }
        />

        <ExamCorrectionTable
          items={items}
          isLoading={isLoading}
          examPublishId={examId}
          currentPage={page}
          totalPages={totalPages}
          totalCount={totalCount}
          onPageChange={setPage}
          onCorrect={handleCorrect}
        />
      </div>

      {/* Modal de correção — key garante remount ao abrir, limpando estado interno */}
      {selectedItem !== null && (
        <CorrectionModal
          key={modalKey}
          examPublishId={examId}
          examItemId={selectedItem.id ?? null}
          questionItem={selectedItem}
          initialAnswerId={selectedAnswerId}
          initialPosition={selectedPosition}
          onClose={() => setSelectedItem(null)}
        />
      )}
    </>
  );
}
